// Stimulus controller for the AI Chat statistics page chart.
// Fetches aggregated token/cost data from the server and renders a Chart.js stacked bar.

import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from "chart.js"

Chart.register(...registerables)

// Service-bucket colors only — tenant charts never expose model names.
const SERIES_COLORS = {
  chat: "rgba(59, 130, 246, 0.8)",
  workflow_runs: "rgba(34, 197, 94, 0.8)",
}

const SERIES_LABELS = {
  chat: "AI Chat",
  workflow_runs: "Workflow futások",
}

export default class extends Controller {
  static values = { url: String }
  static targets = ["chart"]

  connect() {
    this.currentPeriod = "weekly"
    this.chart = null
    this.loadData()
  }

  disconnect() {
    this.chart?.destroy()
  }

  fetchWeekly() {
    this.currentPeriod = "weekly"
    this.element
      .querySelectorAll(".btn-group .btn")
      .forEach((btn, i) => btn.classList.toggle("active", i === 0))
    this.loadData()
  }

  fetchMonthly() {
    this.currentPeriod = "monthly"
    this.element
      .querySelectorAll(".btn-group .btn")
      .forEach((btn, i) => btn.classList.toggle("active", i === 1))
    this.loadData()
  }

  async loadData() {
    try {
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set("period", this.currentPeriod)
      const response = await fetch(url.toString(), {
        headers: { Accept: "application/json" },
      })
      if (!response.ok) throw new Error(`HTTP ${response.status}`)
      const data = await response.json()
      this.renderChart(data)
    } catch (err) {
      console.error("AI stats chart error:", err)
    }
  }

  renderChart(data) {
    const { labels = [], datasets = {} } = data
    const seriesKeys = Object.keys(datasets)

    const chartDatasets = seriesKeys.map((key) => {
      const tokenData = datasets[key].input_tokens.map(
        (inp, i) => inp + (datasets[key].output_tokens[i] || 0)
      )

      return {
        label: SERIES_LABELS[key] || key,
        data: tokenData,
        backgroundColor: SERIES_COLORS[key] || "rgba(148, 163, 184, 0.8)",
        stack: "tokens",
      }
    })

    if (this.chart) {
      this.chart.data.labels = labels
      this.chart.data.datasets = chartDatasets
      this.chart.update()
      return
    }

    this.chart = new Chart(this.chartTarget, {
      type: "bar",
      data: { labels, datasets: chartDatasets },
      options: {
        responsive: true,
        plugins: {
          legend: { position: "bottom" },
          tooltip: {
            callbacks: {
              label: (ctx) => `${ctx.dataset.label}: ${ctx.raw?.toLocaleString()} token`,
            },
          },
        },
        scales: {
          x: { stacked: true },
          y: {
            stacked: true,
            title: { display: true, text: "Tokenek" },
            ticks: { callback: (v) => v.toLocaleString() },
          },
        },
      },
    })
  }
}
